import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/sidebar";
import Home from "./components/home";
import TOS from "./components/tos";
import Privacy from "./components/privacy";
import rumba from "./components/rumba/rumba";
import rumbaFAQ from "./components/rumba/faq";
import XXOO10 from "./components/xxoo10/xxoo10";
import xxoo10FAQ from "./components/xxoo10/faq";
import ufit from "./components/ufit/ufit";
import ufitFAQ from "./components/ufit/faq";
import ContactUs from "./components/contactus";
import ReactGA from "react-ga";

ReactGA.initialize("UA-179717110-1");

class App extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div id="page">
        <div id="container-wrap">
          <BrowserRouter>
            <Sidebar></Sidebar>
            <div id="main">
              <Switch>
                <Route component={Privacy} path="/privacy" />
                <Route component={TOS} path="/tos" />
                <Route component={ContactUs} path="/ContactUs" />
                <Route component={rumbaFAQ} path="/rumba/faq" />
                <Route component={rumba} path="/rumba" />
                <Route component={xxoo10FAQ} path="/xxoo10/faq" />
                <Route component={XXOO10} path="/xxoo10" />
                <Route component={ufitFAQ} path="/ufit/faq" />
                <Route component={ufit} path="/ufit" />
                <Route component={Home} path="/" />
              </Switch>
            </div>
          </BrowserRouter>
        </div>
      </div>
    );
  }
}

export default App;
